<div class="ghostContainer">
    <ap-tabset [tabsetId]="'ghost-console-main-tabset'" [styleClass]="'gtw-tabset'" [type]="'underline'" [responsive]="true" [(activeIndex)]="activeTabIndex" (activeIndexChange)="onTabChange($event)">
        <ap-tab [label]="'Foreign Calc Admin'">
            <div class="ghost-console-wrapper">
                <div class="ghost-console-header">
                    <div class="manualRunContainer">
                        Manual Run
                    </div>
                    <div class="progressJobContainer">
                        <div class="jobIdBlock">
                            <span class="Appkit4-icon icon-hb-full"></span> <span class="jobTxt">Progress Job Id : <span class="jobId">{{progressBar? progressBar.JOB_ID : ''}}</span></span>
                        </div>
                        <div class="progressBarBlock" role="region" aria-label="Job completion progress">
                            <ap-progress [steps]="progressSteps" [activeIndex]="progressActiveIndex" [readonly]="true" [space]="0"></ap-progress>
                        </div>
                        <div class="progressBarDetails">
                           {{progressBar ? progressBar.PER_COMP : 0}}%
                        </div>
                    </div>
                </div>

                <div class="ghost-console-content">
                    <div class="manualRunContentContainer">
                        @for (options of manualSetupOptions; track $index) {
<div class="manualButtons">
                            <ng-container>
                                <span class="buttonTxt">{{options.text}}</span>
                                <div class="toggleBtn">
                                    <ap-toggle (onChange)="switch(options)" [(ngModel)]="options.value" [styleClass]="'a-m-5 a-toggle-small'" [disabled]="options.isDisabled" [ariaLabel]="options.text"></ap-toggle>
                                </div>
                            </ng-container>
                        </div>
}
                        <div class="manualButtons">
                            <div class="ml">
                                <span class="buttonTxt">No Of Runs: </span>
                                <div class="runsSelector">
                                    <ap-dropdown class="m-l-10" [list]="noOfRunsManual" [selectType]="'single'" [title]="'No Of Runs'"
                                    [inputAriaLabel]="'No Of Runs'"
                                        [hideTitleOnInput]="true" [(ngModel)]="selectedNoOfRunsManualItem" (onSelect)="setRuns($event, 'manual');">
                                        @for (item of noOfRunsManual; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                                            [ariaLabel]="setAriaLabel(item, 'No Of Runs')" (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                                    </ap-dropdown>
                                </div>
                            </div>
                            <div class="toggleBtn">
                                <ap-button [label]="'RUN'" class="ap-mr-spacing-3" [btnType]="'secondary'" (onClick)="saveManualRunData()" [disabled]="manualRunSaveBtn || scenarioStatus == 'Y'"></ap-button>
                                @if (manualRunSaveLoader) {
<ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
}
                            </div>
                        </div>
                    </div>

                    <div class="autoRunSetup">
                        <div class="autoRunTxt">
                            <div class="autoRunTxtBlock">
                                <div style="margin-top: 4px;">Auto Run Setup</div>
                                @if (ownershipSetupReady == 'N') {
<div class="ownershipError">
                                    <span class="Appkit4-icon icon-alert-outline" style="font-size: 28px; margin-right: 8px;"></span>
                                    <span style="font-size: 16px;margin-left: 10px;">Ownership has not been setup.</span>
                                </div>
}
                                @if (scenarioStatus == 'S') {
<div class="scenario-lock-status">
                                    <span class="Appkit4-icon icon-location-locked-outline" style="font-size: 28px; margin-right: 8px;"></span>
                                    <span style="font-size: 16px;">This Filing Group is locked and can not be run.</span>
                                </div>
}
                            </div>
                            @if (!autoRunDataLoad) {
<div class="keyListingsBlock">
                                <div style="display: flex;">Tax Year :
                                    <span class="keyValues">&nbsp;{{baseGlobalParams? baseGlobalParams.tax_year : 'NA'}}</span>
                                    <!-- <ap-dropdown class="m-l-10" [list]="taxYearList" [selectType]="'single'" (onSelect)="setJobId($event);">
                                        <ap-dropdown-list-item *ngFor="let item of taxYearList" [item]="item"></ap-dropdown-list-item>
                                    </ap-dropdown> -->
                                    Scenario :
                                    <span class="keyValues">&nbsp;{{baseGlobalParams? baseGlobalParams.scenario : 'NA'}}</span>
                                    <!-- <ap-dropdown class="m-l-10" [list]="scenarioList" [selectType]="'single'" [inputAriaLabel]="'Scenario'" (onSelect)="setJobId($event);">
                                        <ap-dropdown-list-item *ngFor="let item of scenarioList" [item]="item"></ap-dropdown-list-item>
                                    </ap-dropdown> -->
                                    Filing Group :
                                    <!-- <span class="keyValues">{{tableData[0].FILING_GROUP}}</span> -->
                                    &nbsp;<ap-dropdown style="width: 345px;" class="m-l-10" [list]="filingList" [selectType]="'single'" [title]="'Filing Group'"
                                    [inputAriaLabel]="'Filing Group'"
                                        [hideTitleOnInput]="true" [(ngModel)]="selectedFilingGroupItem" (onSelect)="setFilingGroup($event);">
                                        @for (item of filingList; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                                            [ariaLabel]="setAriaLabel(item, 'Filing Group')" (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                                    </ap-dropdown>
                                </div>
                            </div>
}
                        </div>
                        <div class="autoConfigs">
                            <div class="autoRunButtonsBlock">
                                @for (option of autoRunSetupOptions; track $index) {
<div class="autoRunButtons">
                                    <ng-container>
                                        <span class="buttonTxt">{{option.text}}</span>
                                        <div class="toggleBtn">
                                            <ap-toggle (onChange)="switch(option)" [(ngModel)]="option.value" [styleClass]="'a-m-5 a-toggle-small'" [disabled]="option.isDisabled" [ariaLabel]="option.text"></ap-toggle>
                                        </div>
                                    </ng-container>
                                </div>
}
                                <div class="autoRunButtons">
                                    <span style="line-height: 28px;">No Of Runs: </span>
                                    <ap-dropdown class="m-l-10 runsDropdown" [list]="noOfRunsAuto" [selectType]="'single'" [title]="'No Of Runs'"
                                    [inputAriaLabel]="'No Of Runs'"
                                        [hideTitleOnInput]="true" [(ngModel)]="selectedNoOfRunsAutoItem" (onSelect)="setRuns($event, 'Auto');">
                                        @for (item of noOfRunsAuto; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                                            [ariaLabel]="setAriaLabel(item, 'No Of Runs')" (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                                    </ap-dropdown>
                                </div>
                                <!-- <div class="autoRunButtons" *ngIf="ownershipSetupReady == 'N'">
                                    <span class="Appkit4-icon icon-alert-outline" style="font-size: 28px; margin-right: 8px;"></span>
                                    <span style="font-size: 16px;">Ownership has not been setup.</span>
                                </div> -->
                            </div>
                            <div class="scheduleBlock">
                                <div class="scheduleBtn">
                                    <ng-container>
                                        <span class="buttonTxt">{{fixedSchedule.name}}</span>
                                        <div class="toggleBtn">
                                            <ap-toggle (onChange)="scheduleJob(fixedSchedule)" [(ngModel)]="fixedSchedule.value" [styleClass]="'a-m-5 a-toggle-small'" [ariaLabel]="fixedSchedule.text"></ap-toggle>
                                        </div>
                                    </ng-container>
                                </div>
                                @if (showScheduler) {
<div class="ml">
                                    <span>Hours: </span>
                                    <ap-dropdown class="m-l-10 hours-minutes-dd" [list]="hoursList" [selectType]="'single'" [title]="'Hours'"
                                    [inputAriaLabel]="'Hours'"
                                        [hideTitleOnInput]="true" [(ngModel)]="selectedHourItem" (onSelect)="setHour($event);">
                                        @for (item of hoursList; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                                            [ariaLabel]="setAriaLabel(item, 'Hours')" (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                                    </ap-dropdown>
                                </div>
}
                                @if (showScheduler) {
<div class="ml">
                                    <span>Minutes: </span>
                                    <ap-dropdown class="m-l-10 hours-minutes-dd" [list]="secondsList" [selectType]="'single'" [title]="'Minutes'"
                                    [inputAriaLabel]="'Minutes'"
                                        [hideTitleOnInput]="true" [(ngModel)]="selectedMinuteItem" (onSelect)="setMinute($event);">
                                        @for (item of secondsList; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                                            [ariaLabel]="setAriaLabel(item, 'Minutes')" (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                                    </ap-dropdown>
                                </div>
}
                                @if (showScheduler) {
<ap-button [label]="'ADD'" class="ap-mr-spacing-3 addSchBtn" [btnType]="'primary'" (onClick)="addSchedules()"></ap-button>
}
                                @if (showScheduler) {
<div style="color: red; margin-top: 16px;">{{scheduleMsg}}</div>
}
                            </div>
                        </div>

                        <div class="startRunningContainer">
                            <div class="startDateBlock">
                                <div class="date-field-container">
                                    <div class="datePickerTxt">
                                        Start Running On
                                    </div>
                                    <div class="datePicker">
                                        <ap-field [datepicker]="true"
                                            [title]="''"
                                            [hideTitleOnInput]="true"
                                            [editable]="true"
                                            [dpAutoClose]="true"
                                            [dpType]="'single'"
                                            [dpRange]="false"
                                            [dpDateformat]="'MM/dd/yyyy'"
                                            [dpSelectedDates]="startDateArray"
                                            (dpSelectedDatesChange)="onStartDateChanged($event)"
                                            class="single-date-picker">
                                            <input appkit-field aria-label="Start Running On" />
                                        </ap-field>
                                    </div>
                                </div>

                                <div class="date-field-container" style="margin-left: 20px;">
                                    <div class="datePickerTxt">
                                        End Running On
                                    </div>
                                    <div class="datePicker">
                                        <ap-field [datepicker]="true"
                                            [title]="''"
                                            [hideTitleOnInput]="true"
                                            [editable]="true"
                                            [dpAutoClose]="true"
                                            [dpType]="'single'"
                                            [dpRange]="false"
                                            [dpDateformat]="'MM/dd/yyyy'"
                                            [dpSelectedDates]="endDateArray"
                                            (dpSelectedDatesChange)="onEndDateChanged($event)"
                                            class="single-date-picker">
                                            <input appkit-field aria-label="End Running On" />
                                        </ap-field>
                                    </div>
                                </div>

                                <div class="ap-pl-spacing-6 autoRunActions" style="margin-top: 19px;display: flex;">
                                    <ap-button [label]="'SAVE'" class="ap-mr-spacing-3" [btnType]="'primary'" (onClick)="saveAutoRunData()" [disabled]="autoRunSaveBtn || scenarioStatus == 'Y'"></ap-button>
                                    <!-- <ap-loading *ngIf="autoRunSaveLoader" class="saveLoader" [size]="'24px'" [colorName]="'a-primary'"></ap-loading> -->
                                    @if (autoRunSaveLoader) {
<div class="text-center rounded"><ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading></div>
}
                                </div>

                                <!-- <div class="scenario-lock-status" *ngIf="scenarioStatus == 'S'">
                                    <span class="Appkit4-icon icon-location-locked-outline" style="font-size: 28px; margin-right: 8px;"></span>
                                    <span style="font-size: 16px;">This Scenario is locked and can not be run.</span>
                                </div> -->
                            </div>
                            @if (showScheduler) {
<div class="tagsBlock">
                                <div class="tagsContainer" style="margin-top: 12px;">
                                    @if (schedulesList.length == 0) {
<div style="text-align: center;">No Schedules Added.</div>
}
                                    @for (sch of schedulesList; track $index; let i = $index) {
<div class="tags">
                                        <span class="" style="padding-left: 10px;">{{sch}}</span>
                                        <ap-button [label]="'x'" [ariaLabel]="'Remove schedule'" class="ap-mr-spacing-3 addSchBtn" [btnType]="'text'" (onClick)="removeSchedules(i)"></ap-button>
                                    </div>
}
                                </div>
                            </div>
}
                        </div>

                        <div class="endRunningContainer">
                            <div class="actionBtns">
                                <!-- <div class="datePickerTxt">
                                    End Running On
                                </div> -->
                                <div class="datePicker display">
                                    <!-- <ap-date-picker type="singleCalendar" dateFormat="yyyy-MM-dd" (onChange)="datePickerChange($event)" [(ngModel)]="dateRangeSelection.endDate" themeLevel="a-apply-theme-level-3" [minDate]="minDate"></ap-date-picker> -->
                                    <!-- <div class="a-pl-20 autoRunActions">
                                        <ap-button [btnText]="'SAVE'" class="ap-mr-spacing-3" [config]="primaryConfig" (onBtnClick)="saveAutoRunData()" [isDisabled]="autoRunSaveBtn || scenarioStatus == 'Y'"></ap-button>
                                        <ap-loading *ngIf="autoRunSaveLoader" [size]="'24px'" [colorName]="'a-primary'"></ap-loading>
                                    </div> -->
                                    <div class="toggleBtn autoRunActions">
                                        <ap-button [label]="'Refresh Table Data'" class="ap-mr-spacing-3" [btnType]="'secondary'" (onClick)="getGhostJobTableData();"></ap-button>
                                    </div>
                                    <div class="toggleBtn autoRunActions">
                                        <!-- <ap-button [btnText]="'Compare Data'" class="ap-mr-spacing-3" [config]="secondaryConfig" [isDisabled]="compareBtn" (onBtnClick)="compareData();"></ap-button> -->
                                        <ap-button [label]="'Compare Data'" class="ap-mr-spacing-3" [btnType]="'secondary'" (onClick)="compareData();"></ap-button>
                                    </div>
                                    <!-- <div *ngIf="compareBtn"><span *ngIf="!compareBtn" class="Appkit4-icon icon-alert-fill compareWarning"></span> <span class="compareWarning"> {{compareJobsError}}</span></div> -->
                                    <!-- <div class="ml">
                                        <div class="autoRunsContainer">
                                            <span style="line-height: 28px;">No Of Runs: </span>
                                            <ap-dropdown class="m-l-10 runsDropdown" [list]="noOfRunsAuto" [selectType]="'single'" [inputAriaLabel]="'No Of Runs'" (onSelect)="setRuns($event, 'Auto');">
                                                <ap-dropdown-list-item *ngFor="let item of noOfRunsAuto" [item]="item"></ap-dropdown-list-item>
                                            </ap-dropdown>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                            <div class="errorMsgBlock">
                                @if (showFailedMsg) {
<div class="noRecordsContainer" style="font-size: 12px; padding: 8px;margin: 0;">
                                    {{failedJobErrorMsg}}
                                </div>
}
                            </div>
                        </div>
                        <div>
                @if (autoRunDataLoad) {
<div>
                <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
                            </div>
}
                            @if (!autoRunDataLoad && tableData.length == 0) {
<div class="noRecordsContainer">
                                No Records Found
                            </div>
}
                            @if (!autoRunDataLoad && tableData.length > 0) {
<div class="a-panel code-wrapper table">
                                <div class="col-12  gray-container table-content">
                                    <ap-table [data]="paginatedTableData" [striped]="true">
                                        <table>
                                        <caption class="sr-only">Manual run requests</caption>
                                        <thead class="a-thead">
                                            <tr>
                                                <!-- <th ></th> -->
                                                <th>Request Id</th>
                                                <th>Job Id</th>
                                                <th>Status</th>
                                                <!-- <th>Tax Year</th>
                                                <th>Scenario</th>
                                                <th>Filing Group</th> -->
                                                <th>Run By</th>
                                                <th>Run Type</th>
                                                <th>Run Date</th>
                                                <th>Run Time (Min)</th>
                                                <th>Look Through</th>
                                                <th>FTC</th>
                                                <th>Main Calcs</th>
                                                <th>GILTI</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody class="a-tbody tbody-regular tbody-hover">
                                            @for (item of paginatedTableData; track $index; let i = $index) {
<tr>
                                                <!-- <td ><ap-checkbox [checked]="item.selected" [value]="item.selected" [(ngModel)]="item.selected" (onCheck)="selectedJobId($event, item, i, item.selected);"> </ap-checkbox></td> -->
                                                <td>{{item.REQUEST_KEY}}</td>
                                                <td>{{item.JOB_ID}}</td>
                                                <td>
                                                    @if (item.STATUS == 'STARTED') {
<div class="status yellow"></div>
}
                                                    @if (item.STATUS == 'CREATED') {
<div class="status blue"></div>
}
                                                    @if (item.STATUS == 'FAILED' || item.STATUS == 'ERROR') {
<div class="status red"></div>
}
                                                    @if (item.STATUS == 'SUCCESS' || item.STATUS == 'PASSED') {
<div class="status green"></div>
}
                                                </td>
                                                <!-- <td ap-tooltip [tooltipContent]="template1" [direction]="'right'" [tooltipId]="'ghost-status-detail'" ariaDescribedby="ghost-status-detail" [trigger]="'click'">{{item.STATUS}}</td> -->
                                                <!-- <td ap-tooltip [tooltipContent]='item.STATUS' [direction]="'top'" [tooltipId]="'ghost-status-text'" ariaDescribedby="ghost-status-text">{{item.STATUS}}</td> -->
                                                <!-- <ng-template #template1>
                                                    <div class="tooltip-inner a-p-30 d-block a-min-width-360">
                                                        <div class="a-h3 text-white text-left">Lorem ipsum dolor sit amet</div>
                                                        <div class="a-h4 customize-tooltip-text font-weight-normal text-left ap-mt-spacing-3">consect adipiscing elit. In qua si
                                                            nihil est praeter rationem, sit in una virtute finis bonorum; Atque his de rebus et splendida
                                                            est eorum et illustris oratio.
                                                        </div>
                                                    </div>
                                                </ng-template> -->
                                                <!-- <td>{{item.TAX_YEAR}}</td>
                                                <td>{{item.SCENARIO}}</td>
                                                <td>{{item.FILING_GROUP}}</td> -->
                                                <td>{{item.CREATED_BY}}</td>
                                                <td>{{item.REQUEST_MODE}}</td>
                                                <td>{{item.CREATED_ON}}</td>
                                                <td>{{item.TIME_TO_COMPLETE}}</td>
                                                <td>{{item.LOOK_THROUGH}}</td>
                                                <td>{{item.ELIGIBILITY}}</td>
                                                <td>{{item.MAIN_CALCS}}</td>
                                                <td>{{item.GILTI_FLAG ? item.GILTI_FLAG : ''}}</td>
                                                <td class="hyperLink" style="cursor: pointer;padding-right: 0;" (click)="showError(item)"><span style="float: left;"><span class="Appkit4-icon icon-view-fill" style="color: blue;font-size: 18px;"></span></span>@if (item.STATUS == 'CREATED') {
<ap-button [label]="'x'" [ariaLabel]="'Remove job'" class="ap-mr-spacing-3 addSchBtn" [btnType]="'text'" (onClick)="removeJob(item.REQUEST_KEY)"></ap-button>
}</td>
                                                <!-- <td class="hyperLink" (click)="showMore('compare-data-modal')">Compare</td> -->
                                            </tr>
}
                                        </tbody>
                                        </table>
                                    </ap-table>
                                    <!-- Pagination component for first table -->
                                    @if (tableData.length > 0) {
<gtw-pagination-wrapper 
                                       
                                        [totalItems]="tableData.length"
                                        [pageSizeOptions]="[5, 8, 12]"
                                        [(pageSize)]="tablePageSize"
                                        [(currentPage)]="tableCurrentPage"
                                        (paginationChange)="onTablePaginationChange($event)">
                                    </gtw-pagination-wrapper>
}
                                </div>
                            </div>
}
                            @if (tableData.length > 0) {
<div class="legendsContainer">
                                <div class="legendBlock">
                                    <div class="status yellow"></div>
                                    <div class="txt">Started</div>
                                </div>
                                <div class="legendBlock">
                                    <div class="status blue"></div>
                                    <div class="txt">Created</div>
                                </div>
                                <div class="legendBlock">
                                    <div class="status red"></div>
                                    <div class="txt">Failed / Error</div>
                                </div>
                                <div class="legendBlock">
                                    <div class="status green"></div>
                                    <div class="txt">Success / Passed</div>
                                </div>
                            </div>
}
                        </div>
                    </div>
                </div>

                <!-- <div class="text-center a-p-10">
                    <ap-modal #baseModal (onClose)="modalClose()" appModalId="show-more-modal"
$1 [ariaLabel]="'Show more details'">
27741
                        <div slot="content">
                            <div class="modal-dialog" role="document" tabindex="-1">
                                <div class="modal-content">
                                    <div class="a-modal-header">
                                        <div class="flex-fill">
                                            <span class="a-h4">Title</span>
                                        </div>
                                        <button aria-label="Close" class="icon-wrapper" data-dismiss="modal" (click)="closeModal('show-more-modal')">
                                            <span class="Appkit4-icon icon-close-fill a-close-btn"></span>
                                        </button>
                                    </div>
                                    <div class="a-modal-body">
                                        Lorem ipsum dolor sit amet, @firstlastname adipiscing elit. Sed ac diam elit. Vivamus enim diam, luctus et scelerisque
                                        vitae, congue sed purus
                                    </div>
                                    <div class="a-modal-footer justify-content-end">
                                        <ap-button [btnType]="'text'" [label]="'OK'" (onClick)="closeModalOk('show-more-modal')"></ap-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ap-modal>
                </div> -->

            </div>
        </ap-tab>
        <ap-tab [label]="'Change Details'">
            @if (changeDetailsTabVisited) {

            <div class="a-panel-wrapper p-3 change-details-wrapper">
                <div style="padding-top: 6px; padding-left: 6px;"><span>Select Job Id: </span></div>
                <ap-dropdown style="width: 150px;" class="m-l-10" [list]="dropdownList" [selectType]="'single'" [title]="'Select Job Id'"
                [inputAriaLabel]="'Select Job Id'"
                    [hideTitleOnInput]="true" [(ngModel)]="selectedJobIdItem" (onSelect)="setJobId($event);">
                    @for (item of dropdownList; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                        [ariaLabel]="setAriaLabel(item, 'Job Id')" (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                </ap-dropdown>
                <div class="toggleBtn autoRunActions m-l-10">
                    <ap-button [label]="'View Details'" class="ap-mr-spacing-3" [btnType]="'secondary'" [compact]="true" (onClick)="viewDetails();"></ap-button>
                </div>
                @if (changeDetailsLoader) {
<ap-loading class="changeDetailsLoader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
}
            </div>
            @if (jobData.length < 1) {
<div class="noRecordsContainer">
                No Records Found
            </div>
}
            @if (showJobData) {
<div class="a-panel-wrapper p-3 change-details-wrapper-table">
                <div class="a-panel code-wrapper table">
                    <div class="col-12  gray-container table-content">
                        <ap-table [data]="paginatedJobData" [striped]="true">
                            <table>
                                        <caption class="sr-only">Job progress details</caption>
                            <thead class="a-thead">
                                <tr>
                                    <th>JOB ID</th>
                                    <th>PROCESS NAME</th>
                                    <th>STATUS</th>
                                    <th>ESTIMATED COMPLETION TIME</th>
                                    <th>COMPLETION PERCENTAGE</th>
                                </tr>
                            </thead>
                            <tbody class="a-tbody tbody-regular tbody-hover">
                                @for (item of paginatedJobData; track $index; let i = $index) {
<tr>
                                    <td>{{item.JOB_ID}}</td>
                                    <td>{{item.PROCESS_NAME}}</td>
                                    <td>{{item.STATUS}}</td>
                                    <td>{{item.EXPECTED_TIME_TO_COMPLETE}}</td>
                                    <td>{{item.COMPLETION_PERCENTAGE}}</td>
                                </tr>
}
                            </tbody>
                            </table>
                        </ap-table>
                        <!-- Pagination component for job table -->
                        @if (jobData.length > 0) {
<gtw-pagination-wrapper 
                           
                            [totalItems]="jobData.length"
                            [pageSizeOptions]="[5, 8, 12]"
                            [(pageSize)]="jobTablePageSize"
                            [(currentPage)]="jobTableCurrentPage"
                            (paginationChange)="onJobTablePaginationChange($event)">
                        </gtw-pagination-wrapper>
}
                    </div>
                </div>
            </div>
}
            
}
        </ap-tab>
    </ap-tabset>
</div>